/** URL `?tab=` values for invoice overview. */
export const InvoiceOverviewTabParam = {
  OVERVIEW: "overview",
  CLIENT: "client",
} as const;

export type InvoiceOverviewTabParamValue =
  (typeof InvoiceOverviewTabParam)[keyof typeof InvoiceOverviewTabParam];

const TAB_ID_TO_PARAM: Record<string, InvoiceOverviewTabParamValue> = {
  "1": InvoiceOverviewTabParam.OVERVIEW,
  "3": InvoiceOverviewTabParam.CLIENT,
};

const PARAM_TO_TAB_ID: Record<string, string> = {
  [InvoiceOverviewTabParam.OVERVIEW]: "1",
  [InvoiceOverviewTabParam.CLIENT]: "3",
  // Legacy param — line items moved into an accordion on the Overview tab.
  "line-items": "1",
};

export function invoiceOverviewTabIdFromSearchParam(tab: string | null): string {
  if (!tab) return "1";
  return PARAM_TO_TAB_ID[tab] ?? "1";
}

export function searchParamForInvoiceOverviewTabId(
  tabId: string,
): InvoiceOverviewTabParamValue | null {
  return TAB_ID_TO_PARAM[tabId] ?? null;
}

export function isValidInvoiceOverviewTabParam(tab: string | null): boolean {
  if (!tab) return false;
  return Object.prototype.hasOwnProperty.call(PARAM_TO_TAB_ID, tab);
}
